
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.935 15.855l-4.165-4.141-.036.035a7.768 7.768 0 001.051-3.9C15.785 3.513 12.252 0 7.893 0 3.533 0 0 3.514 0 7.849c0 4.334 3.533 7.848 7.892 7.848a7.882 7.882 0 004.95-1.74l4 3.978c.092.09.244.086.34-.01l1.742-1.732c.097-.096.102-.247.01-.338zM7.893 12.608c-2.644 0-4.787-2.13-4.787-4.76 0-2.628 2.143-4.759 4.787-4.759v4.76h4.786c0 2.628-2.143 4.76-4.786 4.76z","fill":"currentColor"}})])
          )
        }
      }
    